export default __webpack_public_path__ + "static/media/cartaoGoldHorizontal.48937536.svg";